import Proxy from "../proxy";
import {EventProxy} from "../../../utils/eventproxy";

export default class Rest extends Proxy {

	getPaymentData(data) {
		return {
			env: this.getOption('env'),
			version: 4,
			currencyCode: YaPay.CurrencyCode.Rub,
			merchantId: this.getOption('merchantId'),
			totalAmount: data.total,
			availablePaymentMethods: this.getOption('availablePaymentMethods'),
		}
	}

	onPayButtonClick() {
		return this.orders()
			.then(result => {
				if (result.status === 'success') {
					return result.data.paymentUrl;
				}
				else {
					this.payment.showError('orders', result.reasonCode, result.reason);
				}
			});
	}

	createPayment(node, paymentData) {
		YaPay.createSession(paymentData, {
			onPayButtonClick: this.onPayButtonClick.bind(this),
			agent: { name: 'CMS-Bitrix', version: '1.0' }
		})
			.then( (paymentSession) => {
				this.widget.removeLoader();
				this.mount(paymentSession);
			})
			.catch( (err) => {
				this.payment.showError('yapayPayment','payment not created', err);
			});
	}

	mount(payment) {
		this.paymentSession = payment;
		this.payment.display.mount(this.payment.element, payment, YaPay.ButtonType.Pay);
		EventProxy.make().fire('bxYapayMountButton');
	}

	unmount() {
		this.payment.display.unmount(this.payment.element, this.paymentSession);
		this.widget.removeToolsDisplay();
	}

	orders() {
		let data = {
			orderId: this.payment.data.id,
			hash: this.payment.data.hash,
			merchantId: this.getOption('merchantId'),
			successUrl: this.getOption('successUrl'),
			failUrl: this.getOption('failUrl'),
		};

		return this.payment.query(this.getOption('restUrl') + 'orders', data);
	}
}